import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.timers.js";
import { mapGetters } from 'vuex';
export default {
  name: 'JobSearch',
  setup: function setup() {
    var _useNuxtApp = useNuxtApp(),
        $route = _useNuxtApp.$route;

    var jobSearch = ref(null);
    var debounce = ref(null);
    var loading = ref(false);
    var clearingFilters = ref(false);
    var viewingBursaries = computed(function () {
      return $route.fullPath.includes('bursaries');
    });
    return {
      jobSearch: jobSearch,
      debounce: debounce,
      loading: loading,
      clearingFilters: clearingFilters,
      viewingBursaries: viewingBursaries
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('jobs', {
    search: 'getSearch',
    filters: 'getFilters',
    industryFilters: 'getIndustryFilters'
  })), {}, {
    filtersCount: function filtersCount() {
      var _this = this;

      var count = 0;

      if (this.filters) {
        Object.keys(this.filters).forEach(function (key) {
          if (_this.filters[key] !== null) count++;
        });
      } else {
        count = null;
      }

      return count;
    }
  }),
  created: function created() {
    this.jobSearch = this.search;
  },
  watch: {
    search: function search() {
      this.jobSearch = this.search;
    }
  },
  methods: {
    debounceSearch: function debounceSearch() {
      var _this2 = this;

      this.loading = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(function () {
        _this2.$store.dispatch('jobs/setCursor', null);

        _this2.$store.dispatch('jobs/setSearch', _this2.jobSearch);

        _this2.$store.dispatch('jobs/getFilteredJobs').then(function () {
          _this2.loading = false;
        });
      }, 500);
    },
    showFilters: function showFilters() {
      this.$store.dispatch('jobs/setShowJobFilters', true);
    },
    clearFilters: function clearFilters() {
      var _this3 = this;

      this.clearingFilters = true;
      var filters = {
        job_type: null,
        location_type: null,
        industries: null,
        interests: null
      };
      this.$store.dispatch('jobs/setSearch', null);
      this.$store.dispatch('jobs/setCursor', null);
      this.$store.dispatch('jobs/setFilters', _objectSpread({}, filters));
      this.$store.dispatch('jobs/setIndustryFilters', []);
      this.$store.dispatch('jobs/getFilteredJobs').then(function () {
        return _this3.clearingFilters = false;
      });
    }
  }
};